import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#8B1538] text-white px-4 py-8 mt-auto" data-id="element-13">
      <div className="max-w-6xl mx-auto" data-id="element-14">
        <h3 className="text-lg font-semibold mb-4 text-center" data-id="element-15">
          Contact Information
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6" data-id="element-16">
          {/* Phone/WhatsApp */}
          <div className="flex flex-col items-center text-center" data-id="element-17">
            <Phone className="h-5 w-5 mb-2 text-[#FECACA]" data-id="element-18" />
            <p className="text-sm text-[#FECACA] mb-1" data-id="element-19">Call/WhatsApp:</p>
            <p className="text-sm" data-id="element-20">8303699990 / 9026625754</p>
          </div>

          {/* Email */}
          <div className="flex flex-col items-center text-center" data-id="element-21">
            <Mail className="h-5 w-5 mb-2 text-[#FECACA]" data-id="element-22" />
            <p className="text-sm text-[#FECACA] mb-1" data-id="element-23">Email:</p>
            <a href="mailto:aiimr.aethe@gmail.com" className="text-sm hover:text-[#FECACA] transition-colors" data-id="element-24">
              aiimr.aethe@gmail.com
            </a>
          </div>

          {/* Location */}
          <div className="flex flex-col items-center text-center" data-id="element-25">
            <MapPin className="h-5 w-5 mb-2 text-[#FECACA]" data-id="element-26" />
            <p className="text-sm text-[#FECACA] mb-1" data-id="element-27">Location:</p>
            <p className="text-sm" data-id="element-28">Lucknow, Uttar Pradesh, India</p>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-[#FECACA]/30 pt-4" data-id="element-29">
          <p className="text-xs text-[#FECACA] text-center" data-id="element-30">
            © 2026 AATMSHAKTI EMPOWERMENT TRUST. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}